import { S3_BASE } from '../../../constants';
import './index.scss';
const lotusIcon = `${S3_BASE}/luocsu/lotus.png`;

export default function LotusDivider(props) {
  return (
    <div style={{
      marginTop: props.marginTop || 15,
    }} className={'lotus-divider'}>
      <img src={lotusIcon} />
      <img src={lotusIcon} />
      <img src={lotusIcon} />
    </div>
  )
}
